export const Phase = {
  CREATED: 'CREATED',
  WAITING_ON_DATA: 'WAITING_ON_DATA',
  READY_TO_PROCESS: 'READY_TO_PROCESS',
  VALIDATING: 'VALIDATING',
  PROCESSING: 'PROCESSING',
  GENERATING_STATICS: 'GENERATING_STATICS',
  GENERATING_CLASSIFICATION: 'GENERATING_CLASSIFICATION',
  CREATIVE_PROCESSING: 'CREATIVE_PROCESSING',
  INDEXING: 'INDEXING',
  SENDING_TO_OUTSTREAMS: 'SENDING_TO_OUTSTREAMS',
  WAITING_ON_OUTSTREAMS: 'WAITING_ON_OUTSTREAMS',
  COMPLETED: 'COMPLETED',
} as const

export type Phase = (typeof Phase)[keyof typeof Phase]

export interface PhaseStep {
  label: string
  phase: Phase
}

export const steps = (
  validatingPhaseLabel?: string | null,
  creativeClassificationEnabled = false,
): PhaseStep[] => [
  { label: 'Created', phase: Phase.CREATED },
  { label: 'Importing', phase: Phase.WAITING_ON_DATA },
  { label: 'Processing', phase: Phase.PROCESSING },
  // If creative classification is enabled, add the 'Generating Classifications' step
  ...(creativeClassificationEnabled
    ? [{ label: 'Generating Classifications', phase: Phase.GENERATING_CLASSIFICATION }]
    : []),
  { label: validatingPhaseLabel || 'Validating Rules', phase: Phase.VALIDATING },
  { label: 'Exporting', phase: Phase.INDEXING },
]

export const phaseProgressMap = {
  [Phase.CREATED]: {
    step: 0,
    progress: 1,
  },
  [Phase.WAITING_ON_DATA]: {
    step: 1,
    progress: 2,
  },
  [Phase.READY_TO_PROCESS]: {
    step: 1,
    progress: 2,
  },
  [Phase.PROCESSING]: {
    step: 2,
    progress: 3,
  },
  [Phase.GENERATING_CLASSIFICATION]: {
    step: 3,
    progress: 4,
  },
  [Phase.CREATIVE_PROCESSING]: {
    step: 3,
    progress: 4,
  },
  [Phase.VALIDATING]: {
    step: 3,
    progress: 4,
  },
  [Phase.GENERATING_STATICS]: {
    step: 4,
    progress: 5,
  },
  [Phase.INDEXING]: {
    step: 4,
    progress: 5,
  },
  [Phase.SENDING_TO_OUTSTREAMS]: {
    step: 4,
    progress: 5,
  },
  [Phase.WAITING_ON_OUTSTREAMS]: {
    step: 5,
    progress: 6,
  },
  [Phase.COMPLETED]: {
    step: 5,
    progress: 6,
  },
}
